import {createFileRoute} from '@tanstack/react-router';
import {TermsAndConditionsPage} from 'pages/login/TermsAndConditionsPage';

export const Route = createFileRoute('/terms-and-conditions')({
  component: TermsAndConditionsPage,
});
